import { AUTH_TOKEN } from "redux/constants/Auth";
import {
  GET_EXPORT_NON_CAMP_INMATES_DATA,
  SET_ALL_CREATE_STORM_NON_INMATES_REGISTRATION,
  SET_ALL_STORM_NON_INMATES_REGISTRATION,
  SET_ALL_UPDATE_STORM_NON_INMATES_REGISTRATION,
  SET_EXPORT_NON_CAMP_INMATES_DATA,
  SET_STORM_NON_INMATES_REGISTRATION,
} from "redux/constants/StormNonInmatesRegistration";

// Define an initial state
const initialState = {
  stormNonInmatesRegistrationData: [],
  stormIsNonInmatesRegistrationDataFetched: false,
  stormNonInmatesRegistrationListingParam: {},
  stormNonCampInmatesRegistrationExportedData: {},
  token: localStorage.getItem(AUTH_TOKEN),
};

// Reducer function
const stormNonInmatesRegistration = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_STORM_NON_INMATES_REGISTRATION:
      return {
        ...state,
        stormNonInmatesRegistrationData: action.payload,
        stormIsNonInmatesRegistrationDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };

    case SET_ALL_CREATE_STORM_NON_INMATES_REGISTRATION:
      // Handle the logic to create a new report here
      // You can update the state accordingly
      // For example, if you want to store the new report data, you can do something like this:

      return {
        ...state,
        stormNonInmatesRegistrationData: action.payload,
        stormIsNonInmatesRegistrationDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };

    case SET_ALL_UPDATE_STORM_NON_INMATES_REGISTRATION:
      return {
        ...state,
        stormNonInmatesRegistrationData: action.payload,
        stormIsNonInmatesRegistrationDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };

    case SET_STORM_NON_INMATES_REGISTRATION:
      return {
        ...state,
        stormNonInmatesRegistrationListingParam: action.payload,
      };

    case GET_EXPORT_NON_CAMP_INMATES_DATA:
      return {
        ...state,
      };

    case SET_EXPORT_NON_CAMP_INMATES_DATA:
      return {
        ...state,
        stormNonCampInmatesRegistrationExportedData: action.payload,
      };

    default:
      return state;
  }
};

export default stormNonInmatesRegistration;
